export default __webpack_public_path__ + "static/frame-1-8a5c2b2b974f7f4cdcaf3c92bead8296.png";